import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import styles from './expandCell.module.scss';

interface IProps {
  isExpanded: boolean,
  expandLabel?: string,
  collapseLabel?: string,
}

const ExpandCell = ({ isExpanded, expandLabel = 'Expand', collapseLabel = 'Collapse' }: IProps) => (
  <Tooltip content={ isExpanded ? collapseLabel : expandLabel }>
    {
      isExpanded ? (
        <IconCollapse className={ styles.expandCollapseBtn } />
      ) : (
        <IconExpand className={ styles.expandCollapseBtn } />
      )
    }
  </Tooltip>
);

export default ExpandCell;
